import React from 'react'

const CaseCard = ({ cardCase, index, location, onClick }:{
    cardCase : any, index : number, location : {lat:number, lng:number}, onClick : (index:number) => void
}) => {
  return (
        <div className="bg-white p-3 rounded-md flex flex-col justify-between" style={{ maxWidth: '300px', minWidth: '300px', maxHeight: '180px', minHeight: '180px' }} onClick={() => onClick(index)} >
            <div className='grid grid-cols-8'>
              <div className='col-span-8'>
                <div className="text-sm text-black font-bold">{cardCase.name}</div>
              </div>
              <div className="flex justify-center mt-2">
                <img src="/icons/location-marker.svg" alt="location marker" className="w-5 h-auto self-start pt-1 mr-1"/>
              </div>
              <div className='col-span-7 mt-2'>
                <div className="text-sm text-gray-600 font-medium">{cardCase.address}</div>
              </div>
              <div className="flex justify-center mt-1">
                <img src="/icons/phone.svg" alt="location marker" className="w-4 h-auto self-start pt-1 mr-1"/>
              </div>
              <div className='col-span-7 mt-1'>
                <div className="text-sm text-gray-500 font-medium">{cardCase.phone}</div>
              </div>
              <div className='col-span-7 mt-4'>
                <a
                  href={'https://www.google.com/maps/search/?api=1&query=' + cardCase.position.lat + ',' + cardCase.position.lng}
                  className="outline-none text-primary-light font-bold ml-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Open in maps
                </a>
              </div>

            </div>
        </div>
  )
}

export default CaseCard
